import React, { Component } from 'react';
// import { Link } from 'react-router-dom'
import T from 'i18n-react';
// import handleViewport from 'react-in-viewport';
import './ProductSmallCard.css'

class ProductSmallCard extends Component {

    getOff = (info) => {
        let temp = 0
        if (info.menu_item_pricing_options) {
            Object.keys(info.menu_item_pricing_options).forEach((item, i) => {
                if (info.menu_item_pricing_options[item].option_discount > temp) {
                    temp = info.menu_item_pricing_options[item].option_discount
                }
            })
        }

        return temp
    }


    handleClick = () => {
        if (this.props.info.enabled) {
            this.props.onClick()
        } else {
            this.setState({
                open: true
            })
        }
    }

    render() {

        const info = this.props.info
        if (info) {
            let Off = parseInt(this.getOff(info))

            return (
                <div className="w-100 h-100">

                    <div className={`ProductSmallCard ${info.menu_item_enabled ? '' : 'ProductSmallCardDisabled'}`} onClick={this.handleClick} >
                        <div className="ProductImgDiv" >
                            <img src={info.menu_item_url_photo} alt="" />
                        </div>
                        <p className={`ProductName ${Off ? 'mb-0' : 'mb-1'}`} >{info.menu_item_name_public}</p>
                        {
                            Off && info.menu_item_enabled
                                ?
                                <T.p className="ProductName" text={{ key: `Menu.UpToOff`, discount: this.getOff(info) }} />
                                :
                                null
                        }

                        {
                            !info.menu_item_enabled
                                ?
                                <p className="OutOfStuckText">({T.translate("Menu.OutOfStock")})</p>
                                :
                                null
                        }

                    </div>


                </div>

            );
        } else {
            return (
                <div className="col-4 pl-1 pr-1">

                </div>

            );
        }

    }
}




export default ProductSmallCard;
